// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeSkeleton-homeSkeletonContainer-Gb1ZE {
  min-height: 630px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 66px 0;
  background-color: var(--skeleton-primary-bg);
}

.HomeSkeleton-homeSkeletonWrapper-womry {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.HomeSkeleton-homeSkeletonLsContainer-SGXux {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.HomeSkeleton-homeSkeletonHeading-i8ikl,
.HomeSkeleton-homeSkeletonPara1-_4UTA,
.HomeSkeleton-homeSkeletonPara2-LyDeT {
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

.HomeSkeleton-homeSkeletonHeading-i8ikl {
  max-width: 615px;
  height: 58px;
  margin-bottom: 18px;
}

.HomeSkeleton-homeSkeletonPara1-_4UTA {
  max-width: 465px;
  height: 28px;
  margin-bottom: 36px;
}

.HomeSkeleton-homeSkeletonPara2-LyDeT {
  max-width: 429px;
  height: 44px;
}

.HomeSkeleton-homeSkeletonImg-x38qQ {
  max-width: 538px;
  height: 496px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

.HomeSkeleton-homeSkeletonImgWrapper-aDGxX {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

@media (max-width: 1199px) and (min-width: 768px) {
  .HomeSkeleton-homeSkeletonHeading-i8ikl {
    height: 48px;
  }
}

@media (max-width: 991px) {
  .HomeSkeleton-homeSkeletonWrapper-womry {
    grid-template-columns: 100%;
  }

  .HomeSkeleton-homeSkeletonImg-x38qQ {
    margin-left: auto;
    margin-right: auto;
  }

  .HomeSkeleton-homeSkeletonImgWrapper-aDGxX {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .HomeSkeleton-homeSkeletonContainer-Gb1ZE {
    min-height: unset;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .HomeSkeleton-homeSkeletonImg-x38qQ {
    height: 400px;
  }
}

@media (max-width: 767px) {
  .HomeSkeleton-homeSkeletonContainer-Gb1ZE {
    padding: 36px 0;
  }

  .HomeSkeleton-homeSkeletonImg-x38qQ {
    max-width: 291px;
    height: 269px;
  }

  .HomeSkeleton-homeSkeletonPara1-_4UTA {
    margin-bottom: 18px;
  }

  .HomeSkeleton-homeSkeletonHeading-i8ikl {
    height: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Home/HomeSkeleton/HomeSkeleton.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;;;EAGE,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAGA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".homeSkeletonContainer {\n  min-height: 630px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 66px 0;\n  background-color: var(--skeleton-primary-bg);\n}\n\n.homeSkeletonWrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.homeSkeletonLsContainer {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.homeSkeletonHeading,\n.homeSkeletonPara1,\n.homeSkeletonPara2 {\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n.homeSkeletonHeading {\n  max-width: 615px;\n  height: 58px;\n  margin-bottom: 18px;\n}\n\n.homeSkeletonPara1 {\n  max-width: 465px;\n  height: 28px;\n  margin-bottom: 36px;\n}\n\n.homeSkeletonPara2 {\n  max-width: 429px;\n  height: 44px;\n}\n\n.homeSkeletonImg {\n  max-width: 538px;\n  height: 496px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n.homeSkeletonImgWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n  .homeSkeletonHeading {\n    height: 48px;\n  }\n}\n\n\n@media (max-width: 991px) {\n  .homeSkeletonWrapper {\n    grid-template-columns: 100%;\n  }\n\n  .homeSkeletonImg {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .homeSkeletonImgWrapper {\n    justify-content: center;\n  }\n\n  .homeSkeletonContainer {\n    min-height: unset;\n  }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n  .homeSkeletonImg {\n    height: 400px;\n  }\n}\n\n@media (max-width: 767px) {\n  .homeSkeletonContainer {\n    padding: 36px 0;\n  }\n\n  .homeSkeletonImg {\n    max-width: 291px;\n    height: 269px;\n  }\n\n  .homeSkeletonPara1 {\n    margin-bottom: 18px;\n  }\n\n  .homeSkeletonHeading {\n    height: 38px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeSkeletonContainer": `HomeSkeleton-homeSkeletonContainer-Gb1ZE`,
	"homeSkeletonWrapper": `HomeSkeleton-homeSkeletonWrapper-womry`,
	"homeSkeletonLsContainer": `HomeSkeleton-homeSkeletonLsContainer-SGXux`,
	"homeSkeletonHeading": `HomeSkeleton-homeSkeletonHeading-i8ikl`,
	"homeSkeletonPara1": `HomeSkeleton-homeSkeletonPara1-_4UTA`,
	"homeSkeletonPara2": `HomeSkeleton-homeSkeletonPara2-LyDeT`,
	"homeSkeletonImg": `HomeSkeleton-homeSkeletonImg-x38qQ`,
	"homeSkeletonImgWrapper": `HomeSkeleton-homeSkeletonImgWrapper-aDGxX`
};
module.exports = ___CSS_LOADER_EXPORT___;
